/**
 * Generates a unique_name from a status name.
 * - Converts to lowercase
 * - Removes special characters (keeps only a-z, 0-9, spaces)
 * - Replaces spaces with underscores
 * - Collapses multiple underscores
 * - Trims leading/trailing underscores
 */
export function generateUniqueName(name) {
    return name
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, '') // Remove special chars
        .replace(/\s+/g, '_') // Replace spaces with underscores
        .replace(/^_+|_+$/g, '') // Trim leading/trailing underscores
        .replace(/_+/g, '_'); // Collapse multiple underscores
}
//# sourceMappingURL=generateUniqueName.js.map